import { Outlet } from "react-router-dom";
import { GeneralNavMenu, GeneralNavMenuProvider } from "./general-nav-menu";
import { useGeneralNavMenuVisible } from "./general-nav-menu/useGeneralNavMenuVisible";

export const NoLayout = () => {
  const showGeneralNavMenu = useGeneralNavMenuVisible();

  return (
    <GeneralNavMenuProvider>
      <div
        className={
          showGeneralNavMenu
            ? "pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))] lg:pb-0"
            : undefined
        }
      >
        <Outlet />
      </div>
      {showGeneralNavMenu ? <GeneralNavMenu /> : null}
    </GeneralNavMenuProvider>
  );
};